export default __webpack_public_path__ + "static/media/loader.00c00441.svg";